import React from 'react';

import PageLayout from '../../../components/PageLayout';

import SunWellness from './SunWellness';

async function action() {
  return {
    title: 'Project - Sun Wellness',
    description:
      'Flux Tech built a calendar integration program for sun wellness so that their reservations could be easily viewed on Google Calendar and AirBnB',
    chunks: ['sun-wellness'],
    component: (
      <PageLayout>
        <SunWellness />
      </PageLayout>
    ),
  };
}

export default action;
